export class DeviceMeasurementRequestViewModel {
	deviceId: string;
	endDate: Date;
	startDate: Date;
}